import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { enumText, translate, isNullOrEmpty, getUserNameToName } from '../../../../utils/util';
import { ENUMS, PERMISSIONS } from '../../../../utils/constants';
import { checkPermission } from '../../../../services/auth';

const PickingListItemOrder = (props) => {
    const getStatus = (value) => translate(`expedition:${enumText(ENUMS.eOrderStatus, value)}`);
    const manageOrder = checkPermission(PERMISSIONS.Expedition.Picking.ManageOrder);
    const orderItemsConfirmed = () => {
        if (!props.data.items) {
            return false;
        }
        const total = props.data.items.length;
        const itemsWaitingAndInProgress = props.data.items.filter((i) => {
            return i.status === ENUMS.eOrderItemStatus.Waiting.value || i.status === ENUMS.eOrderItemStatus.InProgress.value;
        }).length;
        return ((total - itemsWaitingAndInProgress) > 0);
    };

    const totalItems = () => {
        if (!props.data.items) {
            return '';
        }

        const total = props.data.items.filter((i) => i.status !== ENUMS.eOrderItemStatus.WaitingRepicking.value
            && i.status !== ENUMS.eOrderItemStatus.Repicking.value && i.status !== ENUMS.eOrderItemStatus.Canceled.value).length;

        const totalWaiting = props.data.items.filter((i) => i.status === ENUMS.eOrderItemStatus.Waiting.value).length;
        return `${(total - totalWaiting)}/${total}`;
    };

    const checkRepicking = () => {
        if (!props.data.items) {
            return '';
        }
        const totalWaitingRepicking = props.data.items.filter((i) => i.status === ENUMS.eOrderItemStatus.WaitingRepicking.value).length;
        if (totalWaitingRepicking > 0) {
            return translate(`expedition:${ENUMS.eOrderItemStatus.WaitingRepicking.text}`);
        } else {
            const totalRepicking = props.data.items.filter((i) => i.status === ENUMS.eOrderItemStatus.Waiting.value && !isNullOrEmpty(i.orderItemOriginCode)).length;
            if (totalRepicking > 0) {
                return translate(`expedition:${ENUMS.eOrderItemStatus.Repicking.text}`);
            } else {
                return '';
            }
        }
    };

    return (
        <>
            {
                manageOrder === true && props.data.status === ENUMS.eOrderStatus.InProgress.value ? (
                    <>
                        {(orderItemsConfirmed() !== true) ? (
                            <span
                                className="title sixth-text-color right"
                                style={{ position: 'absolute', marginTop: '5px', right: '10px', zIndex: '999' }}
                                onClick={(event) => {
                                    event.preventDefault();
                                    if (props.onClickUnlonckOrder) {
                                        props.onClickUnlonckOrder(event, props.data);
                                    }
                                }}
                            ><i className="material-icons">lock_open</i>
                            </span>

                        ) : null}
                        <span
                            className="title sixth-text-color right"
                            style={{ position: 'absolute', marginTop: '5px', right: '45px', zIndex: '999' }}
                            onClick={(event) => {
                                event.preventDefault();
                                if (props.onClickUserTransfer) {
                                    props.onClickUserTransfer(event, props.data);
                                }
                            }}
                        ><i className="material-icons">contacts</i>
                        </span>
                    </>
                ) : null
            }
            <Link
                className="row"
                style={{ display: 'block', marginBottom: '0px' }}
                to={props.route}
                onClick={(event) => {
                    if (props.onSelectChange) {
                        props.onSelectChange(event);
                    }
                }}
            >
                <span className="title sixth-text-color">{`${props.data.orderCode}`}</span>
                <span
                    className="truncate second-text-color"
                    style={{ marginLeft: '10px' }}
                >
                    {`${props.data.supplierCode} - ${props.data.supplierName}`}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    {getStatus(props.data.status)} | <b>{totalItems()}</b> {manageOrder === true && !isNullOrEmpty(props.data.startedBy) ? ` | ${getUserNameToName(props?.usersFromElog, props.data.startedBy)}` : ''}
                </span>
                {
                    !isNullOrEmpty(checkRepicking()) ? (
                        <span className="truncate red-text" style={{ marginLeft: '10px', display: 'flex' }}>
                            <i className="material-icons">error_outline</i> {checkRepicking()}
                        </span>
                    ) : null
                }
            </Link>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = () => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PickingListItemOrder)));
